"use client";

type EmptyResultsProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

export function EmptyResults({ icon, title, description }: EmptyResultsProps) {
  return (
    <div className="col-span-full flex flex-row justify-center py-8">
      <div className="bg-gray-100 rounded-2xl p-8">
        <div className="space-y-4">
          <div className="bg-primary/10 rounded-full p-4 w-16 h-16 mx-auto flex items-center justify-center">
            {icon}
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-semibold text-foreground text-center">
              {title}
            </h3>
            <p className="text-muted-foreground max-w-md mx-auto text-center">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
